(function () {
  // ---------- Elements ----------
  const dlg = document.getElementById('tc-media-lightbox');
  if (!dlg) return; // snippet missing
  const dlgImg  = document.getElementById('tc-media-lightbox-img');
  const closeBtn = dlg.querySelector('.tc-media-lightbox__close');

  // ---------- (Optional) make sure any built-in zoom cannot steal clicks ----------
  document.addEventListener('DOMContentLoaded', function(){
    try {
      if (window.MagicZoom) {
        if (typeof MagicZoom.stop === 'function') MagicZoom.stop();
        if (MagicZoom.options) MagicZoom.options.autostart = false;
      }
    } catch(_) {}
    document.querySelectorAll('img[data-zoom-image], img[data-zoom-src]').forEach(img => {
      img.removeAttribute('data-zoom-image'); img.removeAttribute('data-zoom-src');
    });
  });

  // ---------- Open / Close ----------
  function closeCompetingPopups() {
    // Click common "close" buttons if a marketing/newsletter popup is open
    const CLOSE_BTN_SELS = [
      '.modal__close', '.modal-close', '.close', '[data-close]', '[aria-label="Close"]',
      '.globo-close', '.klaviyo-close-form', '.klaviyo_modal_close',
      '.popup__close', '.newsletter-popup__close', '.pswp__button--close'
    ];
    document.querySelectorAll(CLOSE_BTN_SELS.join(',')).forEach(btn => {
      const s = getComputedStyle(btn);
      if (s.display !== 'none' && s.visibility !== 'hidden') { try { btn.click(); } catch(_){} }
    });
    // As a fallback, hide obvious modal roots so they don't sit on top
    const MODALS = ['.modal--active','.modal.is-active','.modal[open]','[role="dialog"].is-open','.popup--active','.popup.is-active','.newsletter-popup','.pswp','.mfp-wrap','.mfp-bg','.lightbox'];
    document.querySelectorAll(MODALS.join(',')).forEach(el => { if (el !== dlg) el.style.display = 'none'; });
  }

  function openWith(src, alt) {
    if (!src) return;
    dlgImg.src = src; dlgImg.alt = alt || '';
    dlg.removeAttribute('inert');
    closeCompetingPopups();
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else window.open(src, '_blank'); // very old browsers
    closeBtn?.focus({ preventScroll: true });
  }

  function closeDialog() {
    if (dlg.open) dlg.close();
    dlg.setAttribute('inert','');
    dlgImg.removeAttribute('src');
    closeCompetingPopups();
  }

  // Close controls
  closeBtn?.addEventListener('click', closeDialog);
  dlg.addEventListener('click', e => { if (e.target === dlg) closeDialog(); });
  dlgImg.addEventListener('click', closeDialog);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && dlg.open) closeDialog(); });
  dlg.addEventListener('close', closeCompetingPopups);

  // ---------- Helpers ----------
  // In your snippet, images render with data-zoom + data-zoom-width for full size
  function getFullSrc(img) {
    const data = img.getAttribute('data-zoom') || img.dataset.zoom;
    if (data) return data;

    const srcset = img.getAttribute('srcset');
    if (srcset) {
      const candidates = srcset.split(',').map(s => {
        const [url, desc=''] = s.trim().split(/\s+/);
        const w = parseInt(desc.replace('w',''),10) || 0;
        return { url, w };
      }).filter(c => c.url);
      if (candidates.length) return candidates.sort((a,b)=>b.w - a.w)[0].url;
    }
    const src = img.currentSrc || img.src || '';
    return src.replace(/(_\d+x)(\.(?:jpe?g|png|gif|webp|avif))(\?.*)?$/i, '.$2$3');
  }

  // "Featured" region roots (center image area)
  const FEATURED_SELECTORS = [
    '.product-gallery__carousel',  // your gallery wrapper
    '.product__media', '.product__media-wrapper',
    '[data-product-gallery]','media-gallery','[data-media-gallery]'
  ];

  // Thumbnail list (let theme handle clicks here)
  const THUMB_LIST_SELECTORS = [
    '.product-gallery__thumbnail-list','.product__media-thumbnails','.thumbnail-list','.product__thumbs','[data-thumbnail-list]'
  ];
  const THUMB_ITEM_SELECTORS = [
    '[data-media-thumbnail]','[data-thumbnail]','.product__thumbnail','.product__media-item--thumbnail','.media--thumb','a[href]','button'
  ];
  const PRODUCT_SECTION_SELECTORS = [
    '.product__info-wrapper','.product__media-wrapper','.product','.product-section','#MainContent .product'
  ];

  function closestAny(node, selectors) {
    for (const sel of selectors) { const el = node.closest?.(sel); if (el) return el; }
    return null;
  }

  // Pick the currently visible "featured" IMG (largest visible in the featured area)
  function getCurrentFeaturedImg() {
    const root = document.querySelector(FEATURED_SELECTORS.join(',')) || document.body;
    const imgs = Array.from(root.querySelectorAll('img'))
      .filter(img => !closestAny(img, THUMB_LIST_SELECTORS));
    let best=null, area=0;
    for (const img of imgs) {
      const cs = getComputedStyle(img), r = img.getBoundingClientRect();
      const visible = cs.display!=='none' && cs.visibility!=='hidden' && r.width>20 && r.height>20 && r.bottom>0 && r.right>0 && r.top<innerHeight && r.left<innerWidth;
      if (!visible) continue;
      const a = r.width*r.height;
      if (a>area) { area=a; best=img; }
    }
    return best;
  }

  // ---------- Click logic ----------
  // We listen on <body> in CAPTURE phase so overlays can’t swallow the click.
  document.body.addEventListener('click', function onClickCapture(e){
    // Ignore clicks inside our dialog (so X/backdrop work)
    if (dlg.contains(e.target)) return;
    if (e.button != null && e.button !== 0) return;

    const inThumbList  = !!closestAny(e.target, THUMB_LIST_SELECTORS);
    const onThumbItem  = !!closestAny(e.target, THUMB_ITEM_SELECTORS);
    const inFeatured   = !!closestAny(e.target, FEATURED_SELECTORS);
    const inProductSec = !!closestAny(e.target, PRODUCT_SECTION_SELECTORS);

    // 1) Thumbnails: let the theme switch the featured image
    if (inThumbList && onThumbItem) return;

    // 2) Thumbnail whitespace: block popups, do nothing else
    if (inThumbList && !onThumbItem) { e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); return; }

    // 3) Featured image area: open full size of the CURRENT featured image
    if (inFeatured) {
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
      const img = getCurrentFeaturedImg();
      if (!img) return;
      const full = getFullSrc(img);
      if (!full) return;
      openWith(full, img.alt || '');
      return;
    }

    // 4) Other clicks inside the product section (e.g., grey divider): block marketing popup
    if (inProductSec) { e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); return; }

    // Elsewhere: let the page behave normally
  }, { capture:true });
})();
